import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout'
import VestingPage from './app/vesting/page'
import AdminPage from './app/admin/page'
import { RPC_URL } from 'utils/envs'

require('@solana/wallet-adapter-react-ui/styles.css')

function App() {
  const endpoint = RPC_URL
  const wallets = [new PhantomWalletAdapter()]

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<VestingPage />} />
                <Route path="/vesting" element={<VestingPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  )
}

export default App 
